import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { faRotate, faHeartPulse } from '@fortawesome/free-solid-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-dashboard-auto-refresh-counter',
  standalone: false,
  templateUrl: './dashboard-auto-refresh-counter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard-auto-refresh-counter.component.scss',
})
export class DashboardAutoRefreshCounterComponent {
  @Input() secondsLeft: number | null = null;
  @Input() cacheEnabled: boolean = false;
  @Input() reloading: boolean = false;

  faBuffer = faBuffer;
  rotateIcon = faRotate;
  faHeartPulse = faHeartPulse;
}
